// extracted by mini-css-extract-plugin
export default {"quick-order-mobile-container":"quick-order-mobile-container_FZhBxWOr"};